import gql from 'graphql-tag'

export const LIST = gql`
  query unit($filter: UnitFilter, $offset: Int, $limit: Int!) {
    unit(filter: $filter, offset: $offset, limit: $limit) {
      data {
        id name okei_id okei_name
      }
      total_count
    }
  }
`
